// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-footer_10e6ab13"};